export const prepareImagesFromOtherEditors = (parsedDoc: Document) => {
  const imageElements = parsedDoc.querySelectorAll('img')
  imageElements.forEach((image) => {
    let parent = image.parentElement
    while (parent) {
      if (parent.tagName.toLowerCase() === 'p') {
        const img = image.cloneNode(true)
        parent.parentNode?.insertBefore(img, parent)
        parent.remove()
        break
      }
      parent = parent.parentElement
    }
  })
}
